const CHECKOUT_ORDER_INFO_FAILED_CUSTOM_ACTION =
    'Ha fallado la obtención de la información del pedido de checkout, por lo que se va a manejar el error correspondiente.',
  REDIRECT_RETIRES_FAILED_NO_TMX_CUSTOM_ACTION =
    'El redirect data ha fallado 4 veces, por lo que se añade el script de TMX sin reintentar más',
  TMX_PROFILE_COMPLETED_CUSTOM_ACTION =
    'TMX completó el profiling antes de la llamada a redirect-data',
  TMX_PROFILE_TIMEOUT_CUSTOM_ACTION =
    'TMX no completó el profiling antes del timeout — se llama a redirect-data igualmente',
  TMX_PROFILE_TIMEOUT_MS = 8000,
  TMX_SCRIPT_AND_REDIRECT_DATA_CUSTOM_ACTION =
    'Se ha añadido el script de TMX y se ha hecho la llamada al redirect data de manera exitosa',
  TMX_SCRIPT_AND_REDIRECT_DATA_SKIPPED =
    'No se ha añadido el script de TMX y tampoco se ha hecho la llamada al redirect-data, teniendo en cuenta que el valor de tmxCallDone es: ',
  TMX_SCRIPT_ERROR_CUSTOM_ACTION =
    'Hubo un error en la carga del script de TMX para la posterior valoracion por parte de Riesgos. Se le para el onboarding para que vuelva a intentarlo',
  TMX_SCRIPT_REDIRECT_DATA_FAILED_CUSTOM_ACTION =
    'Ha fallado la llamada al redirect data de TMX, por lo que no se ha añadido el script de TMX y vamos a volver a intentar la llamada. Intento numero: ';

export {
  CHECKOUT_ORDER_INFO_FAILED_CUSTOM_ACTION,
  REDIRECT_RETIRES_FAILED_NO_TMX_CUSTOM_ACTION,
  TMX_PROFILE_COMPLETED_CUSTOM_ACTION,
  TMX_PROFILE_TIMEOUT_CUSTOM_ACTION,
  TMX_PROFILE_TIMEOUT_MS,
  TMX_SCRIPT_AND_REDIRECT_DATA_CUSTOM_ACTION,
  TMX_SCRIPT_AND_REDIRECT_DATA_SKIPPED,
  TMX_SCRIPT_ERROR_CUSTOM_ACTION,
  TMX_SCRIPT_REDIRECT_DATA_FAILED_CUSTOM_ACTION,
};
